import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

// TODO: This fails with embedded navigation (which is used in the Weblink showcase) because window is undefined for some reason.
export default function useQueryParams() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}
